import * as api from '@/api'

interface CharacterData {
  character_id: number
  name: string
  is_previewable: boolean
  base_frag: number
  base_prog: number
  base_over: number
  max_frag: number
  max_prog: number
  max_over: number
  char_type: number
  skill_unlock_level: number
  skill_id_uncap: string
  skill_requires_uncap: boolean
  uncap_over_growth: number
  uncap_prog_growth: number
  uncap_frag_growth: number
  voice: any[]
  uncap_cores: any
  amount: number
  core_type: any[]
  skill_id: string,
  is_available: boolean
}

interface CharacterState {
  characters?: CharacterData[]
  error?: Error
}

const state: CharacterState = {
  characters: undefined,
  error: undefined,
}

const getters = {
  characterData: (state: CharacterState): CharacterData[] | undefined => state.characters
}

const mutations = {
  GET_CHARACTERS_SUCCESS(state: CharacterState, { characters }: { characters: CharacterData[]; }) {
    state.characters = characters
    state.error = undefined
  },

  GET_CHARACTERS_FAIL(state: CharacterState, error: Error) {
    state.error = error
  }
}

const actions = {
  async loadCharacters(
    { commit, getters, dispatch }: any
  ) {
    try {
      const characters = await api.character.getCharacters()
      commit('GET_CHARACTERS_SUCCESS', { characters })
    } catch (error) {
      commit('GET_CHARACTERS_FAIL', error)
      throw error
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
